import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from 'common/react/components/select';
import { getTranslation } from 'common/react/utils/translations';
import { statsLeadersNavSelector } from 'store/modules/statspro/stats-leaders/selectors/nav-selector';
import { changeRound } from 'common/store/modules/statspro/thunks/change-round';
import { statsLeadersActions } from 'common/store/modules/statspro/stats-leaders';

const entireSeasonTranslation = getTranslation(
    'label.statsLeaders.nav.round.entireSeason'
);

export const RoundNavItem = () => {
    const dispatch = useDispatch();
    const nav = useSelector(statsLeadersNavSelector);
    const roundsList = nav?.rounds;
    const rounds = roundsList
        ? [
              { id: -1, name: entireSeasonTranslation, roundNumber: 0 },
              ...roundsList
          ]
        : [];

    return (
        <div className="stats-leaders-nav__select competition-nav__competition-select">
            <Select
                items={rounds}
                itemToString={(round) => round.name}
                icon="calendar"
                type="with-default"
                initialSelectedItem={
                    rounds.length && nav.round.id
                        ? rounds.find((s) => s.id === nav.round.id) ?? ''
                        : ''
                }
                activeItem={
                    rounds.length && nav.round.id
                        ? rounds.find((s) => s.id === nav.round.id) ?? ''
                        : ''
                }
                isReadyToRender={() =>
                    rounds.length &&
                    nav.round.id &&
                    rounds.find((s) => s.id === nav.round.id)
                }
                label={getTranslation('label.statsLeaders.nav.round')}
                onSelectedItemChange={({ selectedItem }) => {
                    dispatch(
                        changeRound({
                            slice: 'stats-leaders',
                            round: selectedItem
                        })
                    );

                    dispatch(
                        statsLeadersActions.setBenchmarking({
                            isActive: false
                        })
                    );
                }}
            />
        </div>
    );
};
